import { useEffect, useState } from 'react';

// T-0152 — the ONE mobile breakpoint, shared with App.tsx's SIDEBAR_COLLAPSE_QUERY
// and every `@media (max-width: 768px)` block: ≤768px is "a phone" (the AppNav rail
// docks to the bottom, the /org inspector becomes a bottom sheet, the topbar folds
// its secondary actions behind ⋯).
export const MOBILE_QUERY = '(max-width: 768px)';

/** Is the viewport phone-sized right now? matchMedia when available (real browsers),
 *  falling back to innerWidth (jsdom has no matchMedia) — the same guard App.tsx's
 *  sidebar collapse uses, so both read the identical breakpoint. */
export function isMobileViewport(): boolean {
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia(MOBILE_QUERY).matches;
  }
  return window.innerWidth <= 768;
}

/** React to the breakpoint: true on a phone-sized viewport, live across resize /
 *  rotation. Components use this ONLY where mobile *behavior* differs (the bottom
 *  sheet, the ⋯ overflow); pure layout stays in CSS media queries. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(isMobileViewport);

  useEffect(() => {
    const sync = (): void => setMobile(isMobileViewport());
    const media = window.matchMedia?.(MOBILE_QUERY);
    sync();
    window.addEventListener('resize', sync);
    media?.addEventListener?.('change', sync);
    return () => {
      window.removeEventListener('resize', sync);
      media?.removeEventListener?.('change', sync);
    };
  }, []);

  return mobile;
}
